import { SVGProps } from 'react';

const SvgLayoutTopPanel2 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M3 4h17a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1zm7 6h10a1 1 0 011 1v8a1 1 0 01-1 1H10a1 1 0 01-1-1v-8a1 1 0 011-1z'
					fill='currentColor'
				/>
				<rect fill='currentColor' opacity={0.3} x={2} y={10} width={5} height={10} rx={1} />
			</g>
		</svg>
	);
};

export default SvgLayoutTopPanel2;
